module.exports = __webpack_public_path__ + "img/stage.8c948615.svg";